module.exports = __webpack_public_path__ + "static/assets/ccb0bda27bef3666a5b4e209b2e95fe8.ttf";